<template>
    <v-dialog id="error-dialog" v-model="dialog" max-width="420px" persistent>
        <v-card :style="fontStyle">
            <v-card-text class="text-center">
                <font-awesome-icon
                    :icon="['fas', 'exclamation-triangle']"
                    class="mt-6 mb-3"
                    size="6x"
                    color="#ff5252"
                />

                <div class="custom-text-h6 mt-1">
                    No user ID found. Please visit this page via the URL in your
                    wallet.
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import fontMixin from "@/mixins/fontMixin.js";

export default {
    name: "CcInvalidIdDialog",
    data() {
        return {
            dialog: false,
        };
    },
    mixins: [fontMixin],
    methods: {
        open() {
            this.dialog = true;
        },
    },
};
</script>
